import { render, staticRenderFns } from "./com-upload.vue?vue&type=template&id=c0d8d3d2&"
import script from "./com-upload.vue?vue&type=script&lang=js&"
export * from "./com-upload.vue?vue&type=script&lang=js&"
import style0 from "./com-upload.vue?vue&type=style&index=0&id=c0d8d3d2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports